/**
 * Cookie Consent Bar — Per-Category Toggles with Bitmask Storage
 * Ported from information-site, adapted for white-label CMS-driven config.
 *
 * Config is read from a hidden element rendered by _cookieConsent.cshtml:
 *   <div id="cookie-optin-config"
 *        data-brand-name="..."
 *        data-cookie-policy-url="..."
 *        data-privacy-policy-url="..."
 *        style="display:none"></div>
 *
 * Cookie: MW_OPTIN  (bitmask integer, 3-month expiry)
 *   0 = rejected all
 *   1 = analytics only
 *   2 = advertising only
 *   3 = both analytics + advertising
 *
 * Version: MW_OPTIN_V = "2" (presence indicates new bitmask format)
 *
 * Legacy migration: If MW_OPTIN_V is absent, old "1" → new "0", old "2" → new "3"
 *
 * Categories:
 *   - "necessary"   — always runs (e.g. Plausible), no consent needed
 *   - "analytics"    — requires consent (e.g. MixPanel), bit 0
 *   - "advertising"  — requires consent (e.g. ad scripts), bit 1
 *
 * Gating pattern: add type="text/plain" data-cookie-category="analytics" to
 * any <script> tag. It will be activated when the user accepts that category.
 *
 * Events dispatched on document:
 *   - "cookieEnabled"       (legacy, fires only when value=3 i.e. both accepted)
 *   - "cookie:analytics"    (fires when analytics bit is set)
 *   - "cookie:advertising"  (fires when advertising bit is set)
 */
(function () {
    var eventRaised = false;

    // Category bitmask constants
    var CAT_ANALYTICS = 1;    // bit 0
    var CAT_ADVERTISING = 2;  // bit 1
    var COOKIE_VERSION = '2';

    // Check if a consent value includes a given category
    function hasConsent(value, category) {
        return (value & category) === category;
    }

    // Migrate legacy cookie format (MW_OPTIN without MW_OPTIN_V)
    function migrateLegacyCookie() {
        var version = getCookieByName('MW_OPTIN_V');
        if (version === COOKIE_VERSION) {
            return; // Already migrated
        }
        var oldValue = getCookieByName('MW_OPTIN');
        if (oldValue === '') {
            return; // No cookie to migrate
        }
        // Map old values to new bitmask: old "1" (reject) → 0, old "2" (accept) → 3
        var newValue;
        if (oldValue === '2') {
            newValue = '3'; // Was accept-all → both categories
        } else {
            newValue = '0'; // Was reject or anything else → reject all
        }
        setCookie('MW_OPTIN', newValue, 3, getLevel());
        setCookie('MW_OPTIN_V', COOKIE_VERSION, 3, getLevel());
    }

    // Activate gated scripts only for consented categories
    function activateConsentedScripts(consentValue) {
        var categoryMap = [
            { name: 'analytics', bit: CAT_ANALYTICS },
            { name: 'advertising', bit: CAT_ADVERTISING }
        ];
        for (var c = 0; c < categoryMap.length; c++) {
            if (!hasConsent(consentValue, categoryMap[c].bit)) {
                continue; // User did not consent to this category
            }
            var scripts = document.querySelectorAll('script[type="text/plain"][data-cookie-category="' + categoryMap[c].name + '"]');
            for (var i = 0; i < scripts.length; i++) {
                var oldScript = scripts[i];
                var newScript = document.createElement('script');
                // Copy all attributes
                for (var j = 0; j < oldScript.attributes.length; j++) {
                    var attr = oldScript.attributes[j];
                    if (attr.name === 'type') {
                        newScript.setAttribute('type', 'text/javascript');
                    } else {
                        newScript.setAttribute(attr.name, attr.value);
                    }
                }
                // Copy inline content
                if (oldScript.textContent) {
                    newScript.textContent = oldScript.textContent;
                }
                oldScript.parentNode.replaceChild(newScript, oldScript);
            }
            // Dispatch category-specific event
            document.dispatchEvent(new Event('cookie:' + categoryMap[c].name));
        }
    }

    // Check if the MW_OPTIN cookie is already set
    function checkCookie() {
        migrateLegacyCookie();
        var cookieValue = getCookieByName('MW_OPTIN');
        if (cookieValue !== '') {
            var numValue = parseInt(cookieValue, 10);
            if (!isNaN(numValue)) {
                closeCookieOptIn();
                if (numValue > 0 && !eventRaised) {
                    activateConsentedScripts(numValue);
                    // Legacy event: only fire when both categories accepted (value=3)
                    if (numValue === 3) {
                        document.dispatchEvent(new Event('cookieEnabled'));
                    }
                    eventRaised = true;
                }
            }
        }
    }

    // Get cookie value by name
    function getCookieByName(name) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.indexOf(name + '=') === 0) {
                return cookie.substring(name.length + 1, cookie.length);
            }
        }
        return '';
    }

    // Set a cookie with name, value, expiration (months), and optional domain
    function setCookie(name, value, expirationMonths, domain) {
        var date = new Date();
        date.setMonth(date.getMonth() + expirationMonths);
        var cookieString = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
        if (domain) {
            cookieString += ';domain=' + domain;
        }
        document.cookie = cookieString;
    }

    // Hide the cookie bar
    function closeCookieOptIn() {
        var el = document.getElementById('cookie-optin');
        if (el) {
            el.style.display = 'none';
        }
    }

    // Get the top-level domain for cookie scope
    function getLevel() {
        return window.location.hostname.split('.').slice(-3).join('.');
    }

    // "Accept all" handler — sets bitmask to 3 (both categories)
    function handleAccept() {
        setCookie('MW_OPTIN', '3', 3, getLevel());
        setCookie('MW_OPTIN_V', COOKIE_VERSION, 3, getLevel());
        closeCookieOptIn();
        if (!eventRaised) {
            document.dispatchEvent(new Event('cookieEnabled'));
            activateConsentedScripts(3);
            eventRaised = true;
        }
    }

    // "Reject all" handler — sets bitmask to 0
    function handleReject() {
        setCookie('MW_OPTIN', '0', 3, getLevel());
        setCookie('MW_OPTIN_V', COOKIE_VERSION, 3, getLevel());
        closeCookieOptIn();
    }

    // "Save preferences" handler — reads toggle states and computes bitmask
    function handleSavePreferences() {
        var value = 0;
        var analyticsToggle = document.getElementById('cookie-toggle-analytics');
        var advertisingToggle = document.getElementById('cookie-toggle-advertising');
        if (analyticsToggle && analyticsToggle.checked) {
            value |= CAT_ANALYTICS;
        }
        if (advertisingToggle && advertisingToggle.checked) {
            value |= CAT_ADVERTISING;
        }
        setCookie('MW_OPTIN', String(value), 3, getLevel());
        setCookie('MW_OPTIN_V', COOKIE_VERSION, 3, getLevel());
        closeCookieOptIn();
        if (value > 0 && !eventRaised) {
            activateConsentedScripts(value);
            if (value === 3) {
                document.dispatchEvent(new Event('cookieEnabled'));
            }
            eventRaised = true;
        }
    }

    // Read CMS-driven config from the hidden element
    function getConfig() {
        var el = document.getElementById('cookie-optin-config');
        if (!el) {
            return {
                brandName: '',
                cookiePolicy: '#',
                privacyPolicy: '#'
            };
        }
        return {
            brandName: el.getAttribute('data-brand-name') || '',
            cookiePolicy: el.getAttribute('data-cookie-policy-url') || '#',
            privacyPolicy: el.getAttribute('data-privacy-policy-url') || '#'
        };
    }

    // Build a toggle row for the preferences panel
    function buildToggleRow(id, label, description, disabled, checked) {
        return '<div class="cookie-category-row">' +
            '<div class="cookie-category-info">' +
                '<strong>' + label + '</strong>' +
                '<span>' + description + '</span>' +
            '</div>' +
            '<label class="cookie-toggle">' +
                '<input type="checkbox" id="' + id + '"' +
                    (checked ? ' checked' : '') +
                    (disabled ? ' disabled' : '') + '>' +
                '<span class="cookie-toggle-slider"></span>' +
            '</label>' +
        '</div>';
    }

    // Build the preferences panel HTML
    function buildPreferencesPanel(isRtl) {
        var necessaryLabel = isRtl ? '\u0636\u0631\u0648\u0631\u064A\u0629' : 'Necessary';
        var necessaryDesc = isRtl ? '\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u062C\u0647\u0648\u0644\u0629 \u0648\u0648\u0638\u0627\u0626\u0641 \u0627\u0644\u0645\u0648\u0642\u0639' : 'Anonymous analytics and site functionality';
        var analyticsLabel = isRtl ? '\u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A' : 'Analytics';
        var analyticsDesc = isRtl ? '\u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637 \u0644\u0644\u062A\u062A\u0628\u0639 \u0645\u062B\u0644 MixPanel' : 'Tracking cookies like MixPanel';
        var advertisingLabel = isRtl ? '\u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A' : 'Advertising';
        var advertisingDesc = isRtl ? '\u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637 \u0644\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0648\u0627\u0644\u062A\u0633\u0648\u064A\u0642' : 'Advertising and marketing cookies';
        var saveLabel = isRtl ? '\u062D\u0641\u0638 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A' : 'Save preferences';

        return '<div class="cookie-preferences">' +
            buildToggleRow('cookie-toggle-necessary', necessaryLabel, necessaryDesc, true, true) +
            buildToggleRow('cookie-toggle-analytics', analyticsLabel, analyticsDesc, false, false) +
            buildToggleRow('cookie-toggle-advertising', advertisingLabel, advertisingDesc, false, false) +
            '<div class="cookie-preferences-save">' +
                '<button class="save-preferences-button button">' + saveLabel + '</button>' +
            '</div>' +
        '</div>';
    }

    // Build the banner HTML
    function generateCookieOptInHtml() {
        var cfg = getConfig();
        var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
        var preferencesPanel = buildPreferencesPanel(isRtl);

        if (isRtl) {
            return '<div id="cookie-optin">' +
                '<div class="cookie-content">' +
                    '<div class="cookie-brand">\u0646\u0633\u062A\u062E\u062F\u0645 \u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637</div>' +
                    '<div class="cookie-consent-text">' +
                        '<p>\u064A\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0627 \u0627\u0644\u0645\u0648\u0642\u0639 \u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637 \u0627\u0644\u0636\u0631\u0648\u0631\u064A\u0629 (\u0628\u0645\u0627 \u0641\u064A \u0630\u0644\u0643 \u0627\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0627\u0644\u0645\u062C\u0647\u0648\u0644\u0629) \u0627\u0644\u062A\u064A \u062A\u0639\u0645\u0644 \u062F\u0627\u0626\u0645\u064B\u0627 \u0644\u0636\u0645\u0627\u0646 \u0639\u0645\u0644 \u0627\u0644\u0645\u0648\u0642\u0639 \u0628\u0634\u0643\u0644 \u0635\u062D\u064A\u062D. ' +
                        '<a href="' + cfg.cookiePolicy + '" target="_blank">\u0627\u0639\u0631\u0641 \u0627\u0644\u0645\u0632\u064A\u062F \u0639\u0646 \u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637</a>.</p>' +
                        '<p>\u0646\u0648\u062F \u0623\u064A\u0636\u064B\u0627 \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637 \u0627\u0644\u0627\u062E\u062A\u064A\u0627\u0631\u064A\u0629 \u0644\u0644\u062A\u062D\u0644\u064A\u0644\u0627\u062A \u0648\u0627\u0644\u0625\u0639\u0644\u0627\u0646\u0627\u062A \u0644\u062A\u062D\u0633\u064A\u0646 \u062A\u062C\u0631\u0628\u062A\u0643. ' +
                        '\u0646\u0633\u062A\u062E\u062F\u0645 \u0647\u0630\u0647 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0645\u0646 \u0623\u062C\u0644 \u062A\u062D\u0633\u064A\u0646 \u0645\u0648\u0642\u0639 ' + cfg.brandName + '.</p>' +
                        '<p>\u0644\u0646\u0639\u0644\u0645 \u0623\u0646 \u0644\u0627 \u0628\u0623\u0633 \u0628\u0647\u0630\u0627. \u0633\u0646\u0633\u062A\u062E\u062F\u0645 \u0645\u0644\u0641\u064B\u0627 \u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637 \u0645\u0646 \u0623\u062C\u0644 \u062D\u0641\u0638 \u0627\u062E\u062A\u064A\u0627\u0631\u0643. \u0627\u0642\u0631\u0623 \u0627\u0644\u0645\u0632\u064A\u062F \u0639\u0646 \u0645\u0627 \u0627\u0644\u0630\u064A \u0646\u0641\u0639\u0644\u0647 \u0628\u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A \u0641\u064A ' +
                        '<a href="' + cfg.privacyPolicy + '" target="_blank">\u0633\u064A\u0627\u0633\u0629 \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629</a> \u0644\u062F\u064A\u0646\u0627</p>' +
                    '</div>' +
                    '<div class="cookie-consent-button">' +
                        '<button class="reject-all-button button">\u0631\u0641\u0636 \u0627\u0644\u0643\u0644</button>' +
                        '<button class="accept-all-button button">\u0642\u0628\u0648\u0644 \u0627\u0644\u0643\u0644</button>' +
                        '<button class="manage-preferences-button">\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u062A\u0641\u0636\u064A\u0644\u0627\u062A</button>' +
                    '</div>' +
                    preferencesPanel +
                '</div>' +
            '</div>';
        }

        return '<div id="cookie-optin">' +
            '<div class="cookie-content">' +
                '<div class="cookie-brand">We use cookies</div>' +
                '<div class="cookie-consent-text">' +
                    '<p>This site uses necessary cookies (including anonymous analytics) that always run to ensure the site works properly. ' +
                    '<a href="' + cfg.cookiePolicy + '" target="_blank">Learn more about cookies.</a></p>' +
                    '<p>We\'d also like to use optional analytics and advertising cookies to improve your experience. ' +
                    'We use this information to improve the ' + cfg.brandName + ' site.</p>' +
                    '<p>Let us know if this is OK. We\'ll use a cookie to save your choice. ' +
                    'Read more about what we do with data in our <a href="' + cfg.privacyPolicy + '" target="_blank">Privacy Policy</a></p>' +
                '</div>' +
                '<div class="cookie-consent-button">' +
                    '<button class="reject-all-button button">Reject all</button>' +
                    '<button class="accept-all-button button">Accept all</button>' +
                    '<button class="manage-preferences-button">Manage preferences</button>' +
                '</div>' +
                preferencesPanel +
            '</div>' +
        '</div>';
    }

    // Wire up event delegation on the banner
    function initCookieOptIn() {
        checkCookie();
        var panel = document.getElementById('cookie-optin');
        if (panel) {
            panel.addEventListener('click', function (e) {
                if (e.target.classList.contains('accept-all-button')) {
                    handleAccept();
                } else if (e.target.classList.contains('reject-all-button')) {
                    handleReject();
                } else if (e.target.classList.contains('manage-preferences-button')) {
                    var prefs = panel.querySelector('.cookie-preferences');
                    if (prefs) {
                        prefs.classList.toggle('is-visible');
                    }
                } else if (e.target.classList.contains('save-preferences-button')) {
                    handleSavePreferences();
                }
            });
        }
    }

    // Insert banner and initialise on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function () {
        // If no config element, cookie bar is disabled — bail out
        if (!document.getElementById('cookie-optin-config')) {
            return;
        }
        var html = generateCookieOptInHtml();
        var body = document.getElementsByTagName('body')[0];
        body.insertAdjacentHTML('afterbegin', html);
        initCookieOptIn();
        checkCookie();
    });
})();
